module.exports = __webpack_public_path__ + "img/clasificacion.de8759a2.gif";